import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';

export default function DashboardContratista({ usuario, onDrillDownLicencias }) {
    const [stats, setStats] = useState({ 
        personal: 0, 
        vehiculos: 0,
        licencias_medicas_12m: 0,
        licencias_medicas_vigentes: 0
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}/api/contratistas/${usuario.id_contratista}/dashboard-stats`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    setStats(data);
                } else {
                    setError('Error al cargar estadísticas');
                }
            } catch (err) {
                setError('Error de conexión');
            } finally {
                setLoading(false);
            }
        };

        if (usuario?.id_contratista) {
            fetchStats();
        }
    }, [usuario]);

    const cardClickableStyle = {
        cursor: onDrillDownLicencias ? 'pointer' : 'default',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease'
    };
    const onCardEnter = e => { if (onDrillDownLicencias) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'; } };
    const onCardLeave = e => { if (onDrillDownLicencias) { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; } };

    if (loading) return <div className="dashboard-loading">Cargando resumen...</div>;

    if (error) return <div className="error-message" style={{ marginTop: '20px' }}>{error}</div>;

    return (
        <div className="dashboard-grid">
            <div className="stat-card">
                <div className="stat-icon">👷</div>
                <div className="stat-info">
                    <h4>Personas Activas</h4>
                    <div className="stat-value">{stats.personal}</div>
                    <p>En la nómina actual</p>
                </div>
            </div>
            <div className="stat-card">
                <div className="stat-icon">🚗</div>
                <div className="stat-info">
                    <h4>Vehículos</h4>
                    <div className="stat-value">{stats.vehiculos}</div>
                    <p>Registrados en el sistema</p>
                </div>
            </div>
            <div
                className="stat-card"
                style={{ borderLeft: '4px solid #10b981', ...cardClickableStyle }}
                onClick={() => onDrillDownLicencias && onDrillDownLicencias('12m')}
                onMouseEnter={onCardEnter}
                onMouseLeave={onCardLeave}
                title={onDrillDownLicencias ? 'Click para ver licencias de los últimos 12 meses' : ''}
            >
                <div className="stat-icon">🏥</div>
                <div className="stat-info">
                    <h4>Licencias Médicas</h4>
                    <div className="stat-value" style={{ color: '#10b981' }}>{stats.licencias_medicas_12m}</div>
                    <p>Últimos 12 meses{onDrillDownLicencias && ' · Click para ver'}</p>
                </div>
            </div>
            <div
                className="stat-card"
                style={{ borderLeft: '4px solid #0ea5e9', ...cardClickableStyle }}
                onClick={() => onDrillDownLicencias && onDrillDownLicencias('vigentes')}
                onMouseEnter={onCardEnter}
                onMouseLeave={onCardLeave}
                title={onDrillDownLicencias ? 'Click para ver licencias vigentes' : ''}
            >
                <div className="stat-icon">✅</div>
                <div className="stat-info">
                    <h4>Licencias Vigentes</h4>
                    <div className="stat-value" style={{ color: '#0ea5e9' }}>{stats.licencias_medicas_vigentes}</div>
                    <p>Válidas y no vencidas{onDrillDownLicencias && ' · Click para ver'}</p>
                </div>
            </div>
        </div>
    );
}
